import React from 'react';
import styled from 'styled-components';
import MuiStarIcon from '@material-ui/icons/Stars';
import colors from 'theme/colors';
import { Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { white } from 'components/unit-toggle/unit-toggle';
import WhiteFxLogo from 'assets/svg/WhiteFxLogo';

const { labelPlatinum, primary } = colors;

const Container = styled.div`
  align-items: center;
  color: ${labelPlatinum};
  display: flex;
  font-size: 14px;
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0px 4px 0px 8px;
  position: relative;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    cursor: 'pointer';
  }
`;

const Label = styled.div`
  display: flex;
  align-items: center;
`;

const FavoriteIconContainer = styled.div`
  margin-right: 4px;
  margin-top: 6px;
  svg {
    fill: ${primary};
    width: 16px;
  }
`;

const CheckBoxContainers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

interface IFormulaModalButtonProps {
  isChecked: boolean;
  disabled?: boolean;
  label: string;
  name: string;
  onClick: () => void;
}

const useStyles = makeStyles({
  myComponent: {
    '& .MuiIconButton-root': {
      paddingLeft: 0,
      paddingRight: 4,
    },
    '& .MuiCheckbox-colorSecondary': {
      color: white,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-checked': {
      color: 'blue',
    },
  },
});

export default ({ isChecked, label, name, onClick }: IFormulaModalButtonProps) => {
  const classes = useStyles();
  const isFavorite = name === 'preferred';
  const isCustom = name === 'custom';

  return (
    <Container className={classes.myComponent}>
      <CheckBoxContainers>
        <Checkbox checked={isChecked} onClick={onClick} name={name} />
        <Label>
          <FavoriteIconContainer>{isFavorite && <MuiStarIcon />}</FavoriteIconContainer>
          {isCustom ? <WhiteFxLogo /> : <Label>{label}</Label>}
        </Label>
      </CheckBoxContainers>
    </Container>
  );
};
